import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { ApplicantComponent } from './applicant.component';
import { InputMaskDirective } from 'src/app/input-mask.directive';

@NgModule({
    imports: [ReactiveFormsModule, CommonModule, FormsModule,InputMaskDirective],
    declarations: [ApplicantComponent],
    exports: [ApplicantComponent,InputMaskDirective],
    providers: [DatePipe]
})
export class ApplicantModule { }
